import { Theme } from '@mui/material';

import { makeStyles } from 'tss-react/mui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import {
  ApiButton,
  ContentTemplate,
  Grid,
  KeyValue,
  Link,
  SectionHeader,
  TitleHeader,
} from 'web-library';
import { useGetSCAcknowledgement } from '../../../api/candidate/special-consideration/@candidate/queries-services/queries';
import LoadingComponent from '../../../components/LoadingComponent';

import RouteKey from '../../../routes/key';
import { stringToLongDateAndShortTimeWithSecond } from '../../../utils/DateUtils';
import { useWOGAA } from '../../../hooks/wogaa';

const { specialConsideration, applicationDetails } = RouteKey['special-consideration'].child;

import {typographyTheme} from "web-library/theme/helper/tssHelper"
// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export const useStyles = makeStyles()((theme) =>
({
  link: {
     ...typographyTheme(theme, 'h3'),
  },
  apiButton: {
    marginBottom: theme.spacing(8),
  },
}));

const ApplicationSummary = () => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const history = useHistory();
  const { uuid: applicationUuid } = useParams<{ uuid: string }>();
  const navigateToApplicationDetails = () => history.push(`${applicationDetails.route}`);
  const backToApplication = () => history.replace(`/${specialConsideration.route}`);
  const { data: scAcknowledgementData } = useGetSCAcknowledgement(applicationUuid);

// Wogaa tracking end for SC application by candidate //
  const { transactionEnd } = useWOGAA('myexamsseab-6461');

  // Wogaa tracking end for SC amendment by candidate //
  const { transactionEnd: transactionEndAmendment } = useWOGAA('myexamsseab-6462');
  transactionEnd(applicationUuid);
  transactionEndAmendment(applicationUuid);

  if (!scAcknowledgementData) {
    return <LoadingComponent />;
  }

  return (
    <>
      <TitleHeader
        title={t(
          'specialConsideration->>ApplyForSpecialConsideration.SubmittedSpecialConsideration'
        )}
        state="success"
      />
      <ContentTemplate>
        <Grid container direction="row" alignItems="flex-start">
          <SectionHeader
            title={t('specialConsideration->>ApplyForSpecialConsideration.ApplicationDetails')}
          />
          <Link className={classes.link} id="link-view-full-summary" onClick={navigateToApplicationDetails}>
            {t('specialConsideration->>ApplyForSpecialConsideration.ViewFullSummary')}
          </Link>
        </Grid>
        <KeyValue
          id="application-date-time"
          keyText={t('specialConsideration->>ApplyForSpecialConsideration.ApplicationDateTime')}
          valueText={stringToLongDateAndShortTimeWithSecond(
            scAcknowledgementData.applicationDateTime
          )}
        />
        <KeyValue
          id="application-id"
          keyText={t('specialConsideration->>ApplyForSpecialConsideration.ApplicationId')}
          valueText={scAcknowledgementData.applicationId}
        />
        <ApiButton
          className={classes.apiButton}
          id="button-back-to-application"
          status="idle"
          type="submit"
          onClick={backToApplication}
        >
          {t('specialConsideration->>ApplyForSpecialConsideration.BackToApplication')}
        </ApiButton>
      </ContentTemplate>
    </>
  );
};

export default ApplicationSummary;
